import type {Ref} from 'react'

import type {StackSectionStackEntry} from '../../../helpers/merge-box-status-calculator/stack-section-status'
import {getEffectiveEntryLineClass} from '../../../helpers/get-effective-entry-line-class'
import {useStackMergeabilityUpdates} from '../../../hooks/use-stack-mergeability-updates'
import {EffectiveEntryStatusLabel} from './EffectiveEntryStatusLabel'
import {EffectiveEntryStatusIcon} from './EffectiveEntryStatusIcon'
import {EffectiveEntryStatus} from '../../../helpers/effective-entry-status'
import {StackEntryNavItem} from './StackEntryNavItem'

export function StackMergeabilityEntryNavItem({
  entry,
  entryRef,
  tabSuffix,
  currentPullRequestId,
  onSwitchBranch,
}: {
  entry: StackSectionStackEntry
  entryRef?: Ref<HTMLAnchorElement>
  tabSuffix: string
  currentPullRequestId: string
  onSwitchBranch?: () => void
}) {
  const effectiveEntryStatus = entry.effectiveEntryStatus ?? EffectiveEntryStatus.NotReady

  useStackMergeabilityUpdates({basePageDataUrl: entry.pull.url, currentPullRequestId, channels: entry.channels})

  return (
    <StackEntryNavItem
      entry={entry}
      tabSuffix={tabSuffix}
      className={getEffectiveEntryLineClass(entry)}
      isTitleMuted={entry.position === 'AFTER'}
      leadingVisual={<EffectiveEntryStatusIcon status={effectiveEntryStatus} />}
      trailingVisual={<EffectiveEntryStatusLabel status={effectiveEntryStatus} />}
      entryRef={entryRef}
      isCurrent={entry.position === 'CURRENT'}
      onClick={onSwitchBranch}
    />
  )
}
